module.exports = __webpack_public_path__ + "media/images/appstore_headerbg-4aa07dd1.jpg";